
import { useEffect, useState, useRef } from "react";

export default function AdverCard({ s, indx }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const adverColor = [
    "bg-[linear-gradient(135deg,#ff6b6b_0%,#ffa500_100%)]",
    "bg-[linear-gradient(135deg,#4facfe_0%,#00f2fe_100%)]",
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`${
        indx % 2 === 0 ? "col-span-full" : "col-span-2"
      } h-[180px] rounded-2xl p-6 text-white relative shadow-lg
      transform hover:scale-[1.02] transition-all duration-300
      ${
        isVisible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-8"
      }
      ${adverColor[indx % 2]}`}
    >
      <div className="absolute top-3 right-3 bg-black/20 px-2 py-1 rounded text-xs font-semibold">
        ads
      </div>

      <div className="relative z-10 flex flex-col justify-center h-full">
        <h3 className="text-lg font-bold mb-2 break-words">
          {s.title}
        </h3>

        <p className="text-sm opacity-90 break-words">
          {s.body}
        </p>
      </div>
    </div>
  );
}
